import React from 'react';

import useNextSalary from '../../hooks/useNextSalary';
import SalaryInfoContent from './SalaryInfoContent';
import SalaryInfoHeader from './SalaryInfoHeader';
import SalaryInfoSkeleton from './SalaryInfoSkeleton';

import './SalaryInfo.scss';

const SalaryInfo: React.FC = () => {
    const { nextSalaryDetails, salaryAccount, nextSalaryError, nextSalaryQueryStatus } = useNextSalary();

    if (nextSalaryError) return null;

    if (nextSalaryQueryStatus === 'pending') {
        return (
            <>
                <SalaryInfoHeader />
                <SalaryInfoSkeleton />
            </>
        );
    }

    if (!salaryAccount || !nextSalaryDetails) return null;

    return <SalaryInfoContent salaryDetails={nextSalaryDetails} salaryAccount={salaryAccount} />;
};

export default SalaryInfo;
